//export values

export const MENUPERMISSION_GPVARIANCE = "P10002";

export const MENUPERMISSION_QTY_EXCEED = "P10003";

export const MENUPERMISSION_SUPPLIER_ACTIVE = "S00406"

export const MENUPERMISSION_USER_INACTIVE = "P10004"